export const namespace = 'subletInvoice/';

export const SubletInvoiceGetters = {
  GET_SUBLET_INVOICE_STATUSES_DISPLAY_LIST: namespace + 'getSubletInvoiceStatusesDisplayList',
  GET_SUBLET_INVOICE_STATUSES: namespace + 'getSubletInvoiceStatuses',
  GET_SUBLET_INVOICE_ITEM_CATEGORIES: namespace + 'getSubletInvoiceItemCategories',
  GET_SUBLET_INVOICE_SUBLET_CODES: namespace + 'getSubletInvoiceSubletCodes',
  GET_SUBLET_INVOICES: namespace + 'getInvoices',
  GET_SUBLET_INVOICE_HISTORY: namespace + 'getSubletInvoiceHistory',
  GET_REVIEW_SUBLET_INVOICES: namespace + 'getReviewSubletInvoices',
  GET_SEARCH_SUBLET_INVOICES: namespace + 'getSearchSubletInvoices',
  GET_FILTERED_SUBLET_INVOICES: namespace + 'getFilteredInvoices',
  GET_SUBLET_INVOICE: namespace + 'getInvoice',
  GET_DB_SUBLET_INVOICE: namespace + 'getDBInvoice',
  GET_IS_FREEZE_PDF: namespace + 'isFreezePdf',
  HAS_CHANGES: namespace + 'hasChanges',
  GET_SUBLET_INVOICE_POS: namespace + 'getSubletInvoicePOs'
};

export const SubletInvoiceActions = {
  SUBMIT_INVOICE: namespace + 'submitInvoice',
  FETCH_SUBLET_INVOICE_LOOKUPS: namespace + 'fetchSubletInvoiceLookups',
  SEARCH_SUBLET_INVOICES: namespace + 'searchSubletInvoices',
  FETCH_SUBLET_INVOICE: namespace + 'fetchInvoice',
  FETCH_SUBLET_INVOICE_HISTORY: namespace + 'fetchSubletInvoiceHistory',
  SAVE_SUBLET_INVOICE: namespace + 'saveSubletInvoice',
  UPDATE_SERVICE_ORDER_FROM_SUBLET_INVOICE: namespace + 'updateServiceOrderFromSubletInvoice',
  COMPLETE_SUBLET_INVOICE: namespace + 'completeSubletInvoice',
  ADD_NEW_SUBLET_LINE_ITEM: namespace + 'addNewSubletLineItem',
  REMOVE_SUBLET_LINE_ITEM: namespace + 'removeSubletLineItem',
  REMOVE_SUBLET_INVOICE: namespace + 'removeSubletInvoice',
  VALIDATE_SUBLET_INVOICE: namespace + 'validateSubletInvoice',
  DOWNLOAD_SUBLET_INVOICE_HISTORY_PDF: namespace + 'dowloadSubletInvoiceHistoryPDF',
  DOWNLOAD_SUBLET_INVOICE_PDF: namespace + 'downloadPDF',
  FETCH_SUBLET_INVOICE_POS: namespace + 'fetchSubletInvoicePos'
};

export const SubletInvoiceMutations = {
  SET_SUBLET_INVOICE_LOOKUPS: namespace + 'setSubletInvoiceLookups',
  SET_SUBLET_INVOICES: namespace + 'setInvoices',
  SET_SEARCH_SUBLET_INVOICES: namespace + 'setSearchSubletInvoices',
  SET_REVIEW_SUBLET_INVOICES: namespace + 'setReviewSubletInvoices',
  SET_SUBLET_INVOICE: namespace + 'setInvoice',
  SET_SUBLET_INVOICE_HISTORY: namespace + 'setSubletInvoiceHistory',
  SET_DB_SUBLET_INVOICE: namespace + 'setDBInvoice',
  SET_FILTERED_SUBLET_INVOICES: namespace + 'setFilteredInvoices',
  SET_COMMON_PROP: namespace + 'setCommonProp',
  SET_LINEITEM_PROP: namespace + 'setLineItemProp',
  SET_DB_LINEITEM_PROP: namespace + 'setDBLineItemProp',
  REMOVE_SUBLET_INVOICE: namespace + 'removeSubletInvoice',
  SET_NEW_SUBLET_LINE_ITEM: namespace + 'setNewSubletLineItem',
  REMOVE_SUBLET_LINE_ITEM: namespace + 'removeSubletLineItem',
  IS_FREEZE_PDF: namespace + 'isFreezePdf',
  SET_SUBLET_INVOICE_POS: namespace + 'setSubletInvoicePOs'
};
